import gql from 'graphql-tag';

export const GET_AUTH_INFO = gql`
  query {
    configuracion {
      authInfo {
        nombreUsuario
        nombre
        accessToken
        rol
        correo
        fotoPerfil
        clienteId
        sucursalesAsociadas
        conceptoPrenominas {
          id
          concepto
        }
      }
    }
  }
`;
